import { Input } from '@mui/joy';

import { IProps } from './NumberInput';
import NumericFormatAdapter from './NumericFormatAdapter';

const NumberInputView = (props: IProps) => {
  return (
    <Input
      {...props}
      onChange={(e: any) => {
        if (props.onChange) {
          props.onChange(e);
        }
      }}
      error={Boolean(props.error)}
      slotProps={{
        input: {
          component: NumericFormatAdapter,
          ...props?.slotProps?.input,
        },
      }}
      sx={{
        maxWidth: props?.maxWidth,
        ...props?.sx,
      }}
    />
  );
};

export default NumberInputView;
